import React, {Fragment} from 'react';
import {installpage} from '../consts';
import styles from '../styles/Messages.module.scss';

export const AboutPopup = ({content, linkText}) => {
    const getLastSpace = linkText.lastIndexOf(' ');
    const link = linkText.slice(getLastSpace + 1);
    const text = linkText.replace(link, ' ');

    const handleClick = () => {
        const location = window.location;
        const prefix = location.search ? '&' : '?';
        const installUrl = location.href + prefix + installpage;
        window.open(installUrl, '_blank');
    };

    return (
        <div className={styles.contentWrapper}>
            {content.split('\n').map((par, i) => (
                <Fragment key={i}>
                    {i > 0 && <br />}
                    {par}
                </Fragment>
            ))}
            <p>
                {text}
                <a className={styles.installationLink} onClick={handleClick}>
                    {link}
                </a>
            </p>
        </div>
    );
};
